<div class="color-yellow display-flex flex-align-center">
  <mat-icon class="mr-5">warning</mat-icon>
  {{ text | translate }}
</div>
